// extracted by mini-css-extract-plugin
module.exports = {"refContainer":"PopoverMenu-module__refContainer--2XIaM","popoverIcon":"PopoverMenu-module__popoverIcon--KMjPg"};